
import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";

@Component({
  props: {
    totalItensServer: {
      type: Number,
      default: 0,
    },
  },
})
export default class PaginatorComponent extends Vue {
  private pagesCombobox = [20, 40, 100];

  page = 1;
  itemsPerPage = 20;

  get selItemsPerPage() {
    return this.pagesCombobox.indexOf(this.itemsPerPage) || 0;
  }

  get mobileBreakpoint() {
    return this.$vuetify.breakpoint.smAndDown;
  }

  get totalPaginas() {
    const sobra = this.$props.totalItensServer % this.itemsPerPage;
    return (
      Math.trunc(this.$props.totalItensServer / this.itemsPerPage) +
        (sobra > 0 ? 1 : 0) || 1
    );
  }

  mounted() {
    const url = new URL(window.location.href);
    const page = url.searchParams.get("page");
    const number = url.searchParams.get("itemsPerPage");

    this.page = page ? parseInt(page) : 1;
    this.itemsPerPage = number ? parseInt(number) : 20;
  }

  onChangeSelectedPage(value: any) {
    this.$router.push({
      query: {
        ...this.$route.query,
        page: value,
      },
    });
    // const url = new URL(window.location.href);
    // const page = url.searchParams.set("page", value);
    // window.history.pushState({}, "", url.toString());

    // this.$router.push({
    //   query: {
    //     ...this.$route.query,
    //     page: value,
    //   },
    // });

    // this.$emit("input");
  }

  onChangeItemsPerPage(value: any) {
    if (value == this.itemsPerPage) return;

    this.$router.push({
      query: {
        ...this.$route.query,
        itemsPerPage: this.pagesCombobox[value]?.toString(),
        page: 1,
      } as any,
    });

    // const url = new URL(window.location.href);
    // const page = url.searchParams.set("page", "1");
    // const number = url.searchParams.set("number", this.pagesCombobox[value]?.toString());

    // window.history.pushState({}, "", url.toString());

    // // this.$router.push({
    // //   query: {
    // //     ...this.$route.query,
    // //     number: this.pagesCombobox[value]?.toString(),
    // //     page: 1,
    // //   } as any,
    // // });

    // this.$emit("input");
  }
}
